import { render } from "./TheFirstToolbar.vue?vue&type=template&id=1fd6cf02"
import script from "./TheFirstToolbar.vue?vue&type=script&lang=js"
export * from "./TheFirstToolbar.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__